// @flow

import common from './locales/ro/common.json'

export const ro = { common }

export default ro
